import * as React from "react";
const SvgArc = (props) => /* @__PURE__ */ React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 100 30", preserveAspectRatio: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M -5,50 A 55,50 0 0 1 105,50", fill: "white" }));
export { SvgArc as ReactComponent };
